



import log from 'loglevel';
import { initializeApp, FirebaseApp } from 'firebase/app';
import { query, limit, orderBy, DocumentData } from 'firebase/firestore';
import { collection, onSnapshot, getFirestore, Firestore } from "firebase/firestore";




import { AppConfigs } from '@/app.configs';
import { IFirebaseConfig } from '@/interfaces/IFirebaseConfig';





import { UserActivityTypes } from '@/constants/UserActivityTypes';
import { IUserActivity } from '@/interfaces/UserActivity/IUserActivity';
import { IOfferUserActivity } from '@/interfaces/UserActivity/IOfferUserActivity';
import { IPayoutUserActivity } from '@/interfaces/UserActivity/IPayoutUserActivity';
import { ISignupUserActivity } from '@/interfaces/UserActivity/ISignupUserActivity';
import { IInHouseUserActivity } from '@/interfaces/UserActivity/IInHouseUserActivity';
import { IOfferWallUserActivity } from '@/interfaces/UserActivity/IOfferWallUserActivity';





/**
 * Firebase configuration object.
 */
const liveUserActivityFirebaseConfig: IFirebaseConfig = {
    appId: AppConfigs.liveUserActivityFirebaseConfig.appId,
    apiKey: AppConfigs.liveUserActivityFirebaseConfig.apiKey,
    projectId: AppConfigs.liveUserActivityFirebaseConfig.projectId,
    authDomain: AppConfigs.liveUserActivityFirebaseConfig.authDomain,
    storageBucket: AppConfigs.liveUserActivityFirebaseConfig.storageBucket,
    messagingSenderId: AppConfigs.liveUserActivityFirebaseConfig.messagingSenderId,
};

// Initialize a new FirebaseApp instance with the LiveUserActivityService configuration
const liveUserActivityFirebaseApp: FirebaseApp = initializeApp(liveUserActivityFirebaseConfig, "LiveUserActivityService");

// Get a Firestore instance for the LiveUserActivityService app
export const liveUserActivityFirestore: Firestore = getFirestore(liveUserActivityFirebaseApp);










/**
 * Sets up a real-time listener for user activity and returns the unsubscribe function.
 * Fetches the latest 45 user activity records.
 * @param callback - The callback function to execute with the user activity data.
 * @returns The unsubscribe function to stop listening for user activity updates.
 */
export const getLiveUserActivityListener = (callback: (LiveUserActivity: IUserActivity[]) => void): (() => void) => {
  const liveUserActivityCollectionRef = collection(liveUserActivityFirestore, 'users_activity');

  // Query to fetch the latest 45 user activity records
  const latestUserActivityQuery = query(
      liveUserActivityCollectionRef,
      orderBy("createdAt", "desc"),
      limit(45)
  );

  const unsubscribe = onSnapshot(latestUserActivityQuery, (snapshot) => {
      const liveUserActivity = snapshot.docs.map(doc => {
          return mapUserActivity(doc.data());
      });
      callback(liveUserActivity);
  }, (error) => {
      log.error("Error listening to live user activity: ", error);
  });

  return unsubscribe;
};









/**
 * Maps Firestore document data to IUserActivity.
 * @param data - Firestore document data.
 * @returns Mapped IUserActivity.
 */
const mapUserActivity = (data: DocumentData): IUserActivity => {
  const id = data.id;
  let userActivity: IUserActivity;

  switch (data.notificationType) {
      case UserActivityTypes.INHOUSETASK:
          userActivity = {
              body: data.body,
              username: data.userName,
              createdAt: data.createdAt,
              userProfilePicture: data.userProfilePicture,
              userActivityType: data.notificationType,
          } as IInHouseUserActivity;
          break;
      case UserActivityTypes.OFFERSCALLBACK:
          userActivity = {
              body: data.body,
              username: data.userName,
              createdAt: data.createdAt,
              userActivityType: data.notificationType,
              userProfilePicture: data.userProfilePicture,
          } as IOfferUserActivity;
          break;
      case UserActivityTypes.OFFERWALL:
          userActivity = {
              body: data.body,
              username: data.userName,
              createdAt: data.createdAt,
              userActivityType: data.notificationType,
              userProfilePicture: data.userProfilePicture,
          } as IOfferWallUserActivity;
          break;
      case UserActivityTypes.PAYOUTSTATUS:
          userActivity = {
              body: data.body,
              username: data.userName,
              createdAt: data.createdAt,
              userActivityType: data.notificationType,
              userProfilePicture: data.userProfilePicture,
          } as IPayoutUserActivity;
          break;
      case UserActivityTypes.USERSIGNUP:
          userActivity = {
              body: data.body,
              username: data.userName,
              createdAt: data.createdAt,
              userActivityType: data.notificationType,
              userProfilePicture: data.userProfilePicture,
          } as ISignupUserActivity;
          break;
      default:
          userActivity = {
              ...data,
              username: data.userName || '',
              createdAt: data.createdAt || '',
              userActivityType: data.notificationType || '',
              userProfilePicture: data.userProfilePicture || '',
          };
          break;
  }
  return userActivity;
};